module.exports = __webpack_public_path__ + "media/images/error-2be5172168ddcba79293ee7d2567ba2c.svg";